import React, { useState } from 'react';
import { 
  FaChevronLeft, 
  FaChevronRight, 
  FaThLarge, 
  FaGlobe, 
  FaUniversity, 
  FaBook, 
  FaCodeBranch, 
  FaExchangeAlt, 
  FaDesktop, 
  FaFileAlt,
  FaChevronDown,
  FaChevronUp
} from 'react-icons/fa';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Style.css';
import { IoIosAddCircle, IoIosEye } from "react-icons/io";

const SuperAdminSidebar = ({ isOpen, isMobile, toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState({});

  const basePath = "/super-admin";
  const menuItems = [
    { name: "DASHBOARD", icon: <FaThLarge />, path: `${basePath}/dashboard` },
    { name: "COUNTRY",   icon: <FaGlobe />,   path: `${basePath}/country` },
    { name: "INSTITUTE", icon: <FaUniversity />, path: `${basePath}/institute` },
    { name: "COURSE",    icon: <FaBook />,     path: `${basePath}/course` },
    { 
      name: "BRANCH OFFICE", 
      icon: <FaCodeBranch />, 
      path: ``,
      subItems: [
        { icon: <IoIosAddCircle />, name: "Add Branch Office",  path: `${basePath}/branch-office/add` },
        { icon: <IoIosEye />,       name: "View Branch Office", path: `${basePath}/branch-office/view` }
      ]
    },
    { name: "COUNSELLOR", icon: <FaExchangeAlt />, path: `${basePath}/counsellor` },
    { 
      name: "FRONT OFFICE", 
      icon: <FaDesktop />, 
      path: ``,
      subItems: [
        { icon: <IoIosAddCircle />, name: "Add Front Office",  path: `${basePath}/front-office/add` },
        { icon: <IoIosEye />,       name: "View Front Office", path: `${basePath}/front-office/view` }
      ]
    },
    { 
      name: "APPLICATION PROCESSOR", 
      icon: <FaFileAlt />, 
      path: ``,
      subItems: [
        { icon: <IoIosAddCircle />, name: "Add Application",  path: `${basePath}/application-processor/add` },
        { icon: <IoIosEye />,       name: "View Application", path: `${basePath}/application-processor/view` }
      ]
    },
  ];

  // Toggle one dropdown at a time
  const toggleDropdown = (itemName) => {
    setOpenItems(prev => {
      const newState = {};
      menuItems.forEach(item => {
        if (item.subItems) {
          newState[item.name] = (item.name === itemName) ? !prev[itemName] : false;
        }
      });
      return newState;
    });
  };

  // Determine active styling if main path OR any sub-path matches
  const isItemActive = (item) => {
    if (location.pathname === item.path) return true;
    return item.subItems?.some(si => location.pathname === si.path);
  };

  // Handle header click: open submenu + navigate to main path
  const handleHeaderClick = (item) => {
    toggleDropdown(item.name);
    navigate(item.path);
    if (isMobile) toggleSidebar();
  };

  // Handle click on sub-item icon when closed
  const handleSubItemIconClick = (path) => {
    navigate(path);
    if (isMobile) toggleSidebar();
  };

  return (
    <div>
      {isMobile && !isOpen && (
        <button onClick={toggleSidebar} className="mobile-toggle">
          <FaChevronRight />
        </button>
      )}
      <div className='position-fixed zindex-100'>
        <div 
          className={`sidebar-container ${isOpen ? 'sidebar-open' : 'sidebar-closed'} ${
            isMobile ? 'mobile-sidebar' : ''} ${isMobile && !isOpen ? 'mobile-hidden' : ''}`
          }
        >
          <div className="toggle-button">{isOpen ? <h2>B<span className='text-danger' style={{fontWeight:"900"}} >M</span>R</h2> : <h4>B<span className='text-danger' style={{fontWeight:"900"}} >M</span>R</h4>}
            
            <button onClick={toggleSidebar} className="buttontoggle">
              {isOpen ? <FaChevronLeft /> : <FaChevronRight />}
            </button>
          </div>

          <nav>
            <ul>
              {menuItems.map(item => (
                <li key={item.name}>
                  {item.subItems ? (
                    <>
                      <div
                        className={`menu-item text-white ${isOpen ? 'justify-start' : 'justify-center'} ${isItemActive(item) ? 'active' : ''}`}
                        onClick={() => handleHeaderClick(item)}
                        style={{ cursor: 'pointer' }}
                      >
                        <span className="icon">{item.icon}</span>
                        {isOpen && (
                          <>
                            <span className="label">{item.name}</span>
                            <span className="ml-auto mx-auto">
                              {openItems[item.name] ? <FaChevronUp /> : <FaChevronDown />}
                            </span>
                          </>
                        )}
                      </div>

                      {/* Expanded submenu when open */}
                      {isOpen && openItems[item.name] && (
                        <ul className="submenu">
                          {item.subItems.map(si => (
                            <li key={si.path}>
                              <NavLink
                                to={si.path}
                                className={({ isActive }) => `submenu-item px-5 ${isActive ? 'active' : ''}`}
                                onClick={() => isMobile && toggleSidebar()}
                              >
                                <span className="icon">{si.icon}</span>
                                <span className="label">{si.name}</span>
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}

                      {/* Icons-only submenu when closed */}
                      {!isOpen && openItems[item.name] && (
                        <div className="submenu-icons-closed">
                          {item.subItems.map(si => (
                            <div
                              key={si.path}
                              className={`submenu-icon ${location.pathname === si.path ? 'active' : ''}`}
                              onClick={() => handleSubItemIconClick(si.path)}
                              title={si.name}
                            >
                              {si.icon}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <NavLink
                      to={item.path}
                      className={({ isActive }) => `menu-item ${isOpen ? 'justify-start' : 'justify-center'} ${isActive ? 'active' : ''}`}
                      onClick={() => isMobile && toggleSidebar()}
                    >
                      <span className="icon">{item.icon}</span>
                      {isOpen && <span className="label">{item.name}</span>}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminSidebar;
